import FloatRight from "../shared/FloatRight";
import FloatLeft from "../shared/FloatLeft";
import Loader from "../shared/Loader";
import Accordion from "../Accordion";
import RoundImage from "../shared/RoundImage";

import AppContext from "../../context/Context";
import { getResource } from "../../context/Actions";
import { useEffect, useContext, useRef } from "react";

const style = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
};

export default function Resource() {
    const { isLoading, dispatch } = useContext(AppContext);
    const currentResource = useRef({});

    useEffect(() => {
        dispatch({ type: "SET_LOADING" });
        const getCurrentResource = async () => {
            const fetchedResource = await getResource(
                window.location.pathname.split("/").pop()
            );
            currentResource.current = fetchedResource;
            // Parse the books
            currentResource.current.booksList = JSON.parse(
                currentResource.current.books
            );
            // Parse the courses
            currentResource.current.coursesList = JSON.parse(
                currentResource.current.courses
            );
            // Parse the youtube links
            currentResource.current.youtubeLinksList = JSON.parse(
                currentResource.current.youtubeLinks
            );
            // Parse the others
            currentResource.current.othersList = JSON.parse(
                currentResource.current.others
            );
            // console.log(currentResource.current);
            dispatch({
                type: "GET_RESOURCE",
            });
        };
        getCurrentResource();
    }, [dispatch]);

    if (isLoading) return <Loader />;

    return (
        <div>
            <div className="container">
                <div className="columns m-2 p-2">
                    <div className="column is-centered">
                        <FloatRight>
                            <div className="card is-shadowless has-text-centered">
                                <div style={style} className="card-image">
                                    <RoundImage
                                        imageUrl={
                                            currentResource.current.imgUrl
                                        }
                                    />
                                </div>
                                <div className="media">
                                    <div className="media-content">
                                        <h1 className="title">
                                            {currentResource.current.name}
                                        </h1>
                                        {/* <h2 className="subtitle is-4">
                                            # Get Started
                                        </h2> */}
                                    </div>
                                </div>
                                <div className="card-content">
                                    <div className="content">
                                        {currentResource.current.content}
                                    </div>
                                </div>
                            </div>
                        </FloatRight>
                    </div>
                    <div className="column">
                        <FloatLeft>
                            <Accordion
                                title="References"
                                books={currentResource.current.booksList}
                                courses={currentResource.current.coursesList}
                            />
                            <Accordion
                                title="Useful Links"
                                youtubeLinks={
                                    currentResource.current.youtubeLinksList
                                }
                                others={currentResource.current.othersList}
                            />
                        </FloatLeft>
                    </div>
                </div>
            </div>
        </div>
    );
}
